module.exports = __webpack_public_path__ + "img/scene-4.f1446ce.svg";